<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="满赠门槛" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.minimum }}
        </template>
      </el-table-column>

      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1" type="success">按金额(元)</el-tag>
          <el-tag v-else-if="scope.row.type === 2" type="warning">按比率(%)</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="赠送额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="满赠门槛" prop="minimum">
          <el-input-number size="small" v-model="form.minimum" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type">
            <el-option label="按金额(元)" :value="1"/>
            <el-option label="按比率(%)" :value="2"/>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送额度" prop="amount">
          <el-input-number size="small" v-model="form.amount" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        listLoading: true,
        listQuery: {},
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          minimum: undefined,
          type: 1,
          amount: undefined,
        },
        rules: {
          minimum: [{ required: true, message: "满赠门槛不能为空", trigger: "blur" }],
          type: [{ required: true, message: "类型不能为空", trigger: "change" }],
          amount: [{ required: true, message: "赠送额度不能为空", trigger: "blur" }],
        },
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/stationmasterChargeBonus/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data;
          this.listLoading = false;
        });
      },
      resetForm() {
        this.form = {
          id: "",
          minimum: undefined,
          type: 1,
          amount: undefined,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/stationmasterChargeBonus/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handleDelete(row) {
        this.$confirm("确定继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/stationmasterChargeBonus/delete",
            method: "post",
            data: {id: row.id},
          }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          })
        }).catch((err) => {
          console.log(err)
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
